import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from 'hooks/useAuth';
import Loader from 'components/Loader';
import { APP_DEFAULT_PATH } from 'config';
import { getStoredRedirectPath } from './AuthGuard';

// ==============================|| GUEST GUARD ||============================== //

export default function GuestGuard({ children }) {
  const { isAuthenticated, isInitialized } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isInitialized && isAuthenticated) {
      // User is already logged in, redirect to intended destination or default
      const redirectPath = getStoredRedirectPath() || APP_DEFAULT_PATH;
      navigate(redirectPath, { replace: true });
    }
  }, [isAuthenticated, isInitialized, navigate]);

  // Show loader while checking authentication
  if (!isInitialized) {
    return <Loader />;
  }

  // Authenticated - will redirect via useEffect
  if (isAuthenticated) {
    return <Loader />;
  }

  // Not authenticated - render login/register page
  return children;
}

GuestGuard.propTypes = { children: PropTypes.node };
